// TODO: @hsiung maybe use a library for this instead?
//  if not then move to shared forms utils
type Validator = (value: string | null | undefined) => string | void;

export const MIN_PASSWORD_LENGTH = 12;

// eslint wants to explicitly return undefined
const required =
  (message: string): Validator =>
  (value) =>
    !value ? message : undefined;

const minLength =
  (min: number, message: string): Validator =>
  (value) =>
    value && value.length < min ? message : undefined;

export const emailValidate = required("Required");

export const existingPasswordValidate = [required("Required")];

export const newPasswordValidate = [
  required("Required"),
  minLength(
    MIN_PASSWORD_LENGTH,
    `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`,
  ),
];
